export const formatDate = (dateString) => {
  const date = new Date(dateString);
  return date.toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit'
  });
};

export const truncateText = (text, maxLength = 100) => {
  if (text.length <= maxLength) return text;
  return text.substring(0, maxLength) + '...';
};

export const getFileIcon = (filename) => {
  const extension = filename.split('.').pop()?.toLowerCase();

  const icons = {
    py: '🐍', js: '📜', jsx: '⚛️', ts: '📘', tsx: '⚛️',
    html: '🌐', css: '🎨', json: '📋', md: '📝', txt: '📄',
    java: '☕', cpp: '⚙️', c: '🔧', php: '🐘', rb: '💎',
    go: '🐹', rs: '🦀', swift: '🐦', kt: '🤖', dart: '🎯',
    sql: '🗃️', yml: '⚙️', yaml: '⚙️', xml: '📰', csv: '📊'
  };

  return icons[extension] || '📁';
};

export const getLanguageFromExtension = (filename) => {
  const extension = filename.split('.').pop()?.toLowerCase();

  const languages = {
    py: 'python', js: 'javascript', jsx: 'javascript',
    ts: 'typescript', tsx: 'typescript', html: 'html',
    css: 'css', json: 'json', md: 'markdown', java: 'java',
    cpp: 'cpp', c: 'c', php: 'php', rb: 'ruby', go: 'go',
    rs: 'rust', swift: 'swift', kt: 'kotlin', dart: 'dart',
    sql: 'sql', yml: 'yaml', yaml: 'yaml', xml: 'xml'
  };

  return languages[extension] || 'text';
};